/*
 * air-reveal.js — shared Sleek-style scroll reveals for converted liquid pages.
 * Used where a page lacks its own initAirMotion (e.g. air-liquid / air-sections.js).
 * Idempotent; safe to load alongside page JS that also calls initAirMotion.
 */
(function () {
  'use strict';
  if (window.__airRevealInit) return;
  window.__airRevealInit = true;

  var REVEAL_OPTS = { rootMargin: '0px 0px -8% 0px', threshold: 0.15 };
  var STAGGER_MS = 80;
  var reducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hasAlchemyPaused(el) {
    var cs = getComputedStyle(el);
    return (
      cs.animationName &&
      cs.animationName.indexOf('alchemy') !== -1 &&
      cs.animationPlayState === 'paused'
    );
  }

  function hasBackgroundImage(el) {
    if ((el.style.backgroundImage || '').indexOf('url') !== -1) return true;
    var cs = getComputedStyle(el);
    return cs.backgroundImage && cs.backgroundImage !== 'none';
  }

  function isInView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.92 && r.bottom > 0;
  }

  function revealEl(el) {
    if (el.__airRevealed) return;
    el.__airRevealed = true;
    el.classList.remove('air-reveal-pending');
    el.classList.add('air-reveal-visible');
  }

  function tagReveal(el, variant, delayMs) {
    if (el.__airRevealTagged) return null;
    el.__airRevealTagged = true;
    el.setAttribute('data-air-reveal', variant || 'fade-up');
    if (delayMs) el.style.setProperty('--air-reveal-delay', delayMs + 'ms');
    el.classList.add('air-reveal-pending', 'air-reveal--' + (variant || 'fade-up'));
    if (reducedMotion || isInView(el)) {
      revealEl(el);
      return null;
    }
    return el;
  }

  function initAirMotion() {
    if (document.__airMotionDone) return;
    document.__airMotionDone = true;

    var toObserve = [];
    var alchemyBg = [];

    function observe(el) {
      if (el && !el.__airRevealed) toObserve.push(el);
    }

    document.querySelectorAll('[data-air-reveal]').forEach(function (el) {
      if (el.__airRevealTagged) return;
      var variant = el.getAttribute('data-air-reveal') || 'fade-up';
      var delay = parseInt(el.getAttribute('data-air-reveal-delay') || '0', 10);
      observe(tagReveal(el, variant, delay));
    });

    document.querySelectorAll('[id^="replo-section-"]').forEach(function (section) {
      section.querySelectorAll('[data-replo-carousel]').forEach(function (carousel) {
        if (hasAlchemyPaused(carousel) && hasBackgroundImage(carousel)) {
          alchemyBg.push(carousel);
          return;
        }
        observe(tagReveal(carousel, 'fade-up', 0));
      });

      var gridIndex = 0;
      section.querySelectorAll('[data-replo-product-handle]').forEach(function (card) {
        if (card.closest('[data-replo-carousel]')) return;
        if (hasAlchemyPaused(card)) return;
        var parent = card.parentElement;
        if (parent && hasAlchemyPaused(parent)) return;
        observe(tagReveal(card, 'fade-up', gridIndex * STAGGER_MS));
        gridIndex++;
      });

      section.querySelectorAll('.trustpilot-widget').forEach(function (widget) {
        var wrap = widget.parentElement;
        if (!wrap || wrap.__airRevealTagged) return;
        observe(tagReveal(wrap, 'fade', 0));
      });
    });

    var nodes = document.querySelectorAll('[data-rid]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.__airRevealTagged || node.closest('[data-replo-carousel]')) continue;
      if (!hasAlchemyPaused(node)) continue;
      if (hasBackgroundImage(node)) {
        alchemyBg.push(node);
        continue;
      }
      node.classList.add('air-reveal--alchemy-override');
      observe(tagReveal(node, 'fade-up', 0));
    }

    function playAlchemy(el) {
      el.style.animationPlayState = 'running';
    }

    if (alchemyBg.length) {
      if (!('IntersectionObserver' in window) || reducedMotion) {
        alchemyBg.forEach(playAlchemy);
      } else {
        var alchemyIo = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                playAlchemy(e.target);
                alchemyIo.unobserve(e.target);
              }
            });
          },
          { rootMargin: '0px 0px -5% 0px', threshold: 0.01 }
        );
        alchemyBg.forEach(function (el) {
          if (isInView(el)) playAlchemy(el);
          else alchemyIo.observe(el);
        });
      }
    }

    if (!toObserve.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      toObserve.forEach(revealEl);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          revealEl(e.target);
          io.unobserve(e.target);
        }
      });
    }, REVEAL_OPTS);

    toObserve.forEach(function (el) {
      if (isInView(el)) revealEl(el);
      else io.observe(el);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  window.AirReveal = { init: initAirMotion };

  ready(initAirMotion);
})();
